<div class="flex align-items-center justify-content-between flex-wrap py-3 card bg-blue-200">
    <div *ngIf="signalData  && !isTHGW" class="flex flex-row align-items-center">
        <p-image *ngIf="signalData.SignalLevel"
            [src]="flagImagePath + getSignalIcon(signalData.SignalLevel) + flagImageFormat" width="40"></p-image>
        <p-image *ngIf="!(signalData.SignalLevel)" [src]="flagImagePath + 'signal_off' + flagImageFormat"
            width="40"></p-image>
        <div *ngIf="signalData.SignalLevel" class="pl-2 text-xl">{{ signalData.SignalLevel }} %</div>
        <div *ngIf="signalData.Operator" class="pl-1 text-xl">- {{ signalData.Operator }}</div>
    </div>
    <div *ngIf="!signalData"></div>
    <div class="flex align-items-center border-round">
        <p-button label="{{ 'READ_SIGNAL_LEVEL' | translate }}" [disabled]="!canReadSignal() || readingSignal"
            (click)="readSignal()" [loading]="readingSignal" [rounded]="false" [text]="true" severity="primary"
            styleClass="font-semibold" *ngIf="!isTHGW">
        </p-button>
    </div>
    <div *ngIf="isTHGW" class="flex flex-row align-items-center">
        <p-image [src]="flagImagePath + getSignalIconThGw() + flagImageFormat" width="40"></p-image>
        <div class="pl-2 text-xl">{{ getSignalTxtThGw() }}</div>
    </div>
</div>